export enum WidgetsLayout {
	TWO = 2,
	THREE = 3,
	FOUR = 4
}